import React from 'react';
import { Card } from 'react-bootstrap';

const unitLabel = (unit) => {
    switch (unit) {
        case 'STEMS': return 'tallos';
        case 'KG': return 'kg';
        case 'UNITS': return 'unidades';
        default: return unit || '';
    }
};

// Snapshot de GDD/DLI en una fecha puntual de la cosecha (inicio/pico/fin).
const SnapshotChip = ({ label, date, gdd, dli }) => {
    if (!date) return null;
    return (
        <div className="bg-white border border-gray-200 rounded-lg px-3 py-2">
            <div className="text-[9px] text-gray-400 font-bold uppercase mb-1">{label}</div>
            <div className="text-xs font-bold text-gray-700 mb-1">{date}</div>
            <div className="flex gap-3 text-[10px]">
                {gdd != null && <span><span className="text-gray-400 font-bold">GDD</span> <span className="font-bold text-orange-600">{Math.round(gdd)}</span></span>}
                {dli != null && <span><span className="text-gray-400 font-bold">DLI Acum.</span> <span className="font-bold text-yellow-600">{Math.round(dli)}</span></span>}
            </div>
        </div>
    );
};

const HarvestHistoryList = ({ harvests }) => {
    const sorted = (harvests || []).slice().sort((a, b) => a.harvestStartDate.localeCompare(b.harvestStartDate));

    if (sorted.length === 0) {
        return (
            <Card className="border-0 shadow-sm rounded-xl overflow-hidden">
                <Card.Header className="bg-white border-b border-gray-100 py-4">
                    <h5 className="mb-0 text-gray-800 font-bold flex items-center">
                        <span className="material-icons-outlined mr-2 text-green-600">eco</span>
                        Cosechas registradas
                    </h5>
                </Card.Header>
                <Card.Body className="p-6 text-center text-gray-400 text-sm">
                    Aún no hay cosechas registradas para este ciclo.
                </Card.Body>
            </Card>
        );
    }

    return (
        <Card className="border-0 shadow-sm rounded-xl overflow-hidden">
            <Card.Header className="bg-white border-b border-gray-100 py-4">
                <h5 className="mb-0 text-gray-800 font-bold flex items-center">
                    <span className="material-icons-outlined mr-2 text-green-600">eco</span>
                    Cosechas registradas
                </h5>
            </Card.Header>
            <Card.Body className="p-6">
                <div className="space-y-3">
                    {sorted.map((harvest, index) => (
                        <div
                            key={harvest.id ?? index}
                            className="bg-gray-50 border border-gray-100 rounded-lg px-4 py-3 space-y-3"
                        >
                            <div className="flex flex-wrap items-center justify-between gap-3">
                                <div className="flex items-center gap-3">
                                    <span className="material-icons text-green-600">eco</span>
                                    <div>
                                        <div className="text-xs font-black text-gray-700 uppercase">Pasada {index + 1}</div>
                                        <div className="text-xs text-gray-500">{harvest.harvestStartDate}</div>
                                    </div>
                                </div>

                                {harvest.quantity != null && (
                                    <span className="text-xs font-bold text-gray-700">{harvest.quantity} {unitLabel(harvest.quantityUnit)}</span>
                                )}
                            </div>

                            <div className="flex flex-wrap gap-3">
                                <SnapshotChip
                                    label="Inicio Pre-pico"
                                    date={harvest.harvestStartDate}
                                    gdd={harvest.gddAtHarvestStart}
                                    dli={harvest.dliAtHarvestStart}
                                />
                                <SnapshotChip
                                    label="Inicio Pico"
                                    date={harvest.harvestPeakDate}
                                    gdd={harvest.gddAtHarvestPeak}
                                    dli={harvest.dliAtHarvestPeak}
                                />
                                <SnapshotChip
                                    label="Final cosecha"
                                    date={harvest.harvestEndDate}
                                    gdd={harvest.gddAtHarvestEnd}
                                    dli={harvest.dliAtHarvestEnd}
                                />
                            </div>
                        </div>
                    ))}
                </div>
            </Card.Body>
        </Card>
    );
};

export default HarvestHistoryList;
